import { useParams } from 'react-router-dom';

import { AppAndroidBuildPage } from '~/components/pages/AppAndroidBuildPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppAndroidBuildRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId} wide>
      <AppAndroidBuildPage appId={appId} />
    </DashboardTemplate>
  );
};
